// extracted by mini-css-extract-plugin
export default {"form":"Form_form__bqhVl","form__lines":"Form_form__lines__wqfZX","form__line":"Form_form__line__0XbBz","form__button":"Form_form__button__aHEj9"};